import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService, ModalService, HomeService } from '../_services';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
declare var jquery: any;
declare var $: any;
@Component({ templateUrl: 'login.component.html' })
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    CurrentTime: any;
  
    // tslint:disable-next-line: variable-name
    mobile_no = '';
    message = '';
    access_token = localStorage.getItem(`${environment.appName}` + '_user');
    logintime = localStorage.getItem(`${environment.appName}` + '_time');
    logouttime = localStorage.getItem(`${environment.appName}` + '_logouttime');
    userId = localStorage.getItem(`${environment.appName}` + '_adminId');
    constructor(
        private formBuilder: FormBuilder,
        private authenticationService: AuthenticationService,
        private modalService: ModalService,
        private toastr: ToastrService,
        private route: ActivatedRoute,
        private homeService: HomeService,
        public translate: TranslateService,
        private router: Router) { }

    ngOnInit() {
        console.log(this.logintime)
        console.log(this.logouttime)
        this.loginForm = this.formBuilder.group({
            username: ['', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
            password: ['', Validators.required]
        });

        // reset login status
        this.authenticationService.logout();
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        // get return url from route parameters or default to '/'
        //    if(this.access_token){
        //       this.router.navigate(['/home']);
        //    }else{
        //     this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        //    }

    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }
    onSubmit() {

        this.submitted = true;
        // stop here if form is invalid
        if (this.loginForm.invalid) {

            return;
        }

        document.body.classList.add('jw-modal-open');
        this.loading = true;

        this.authenticationService.login(this.f.username.value, this.f.password.value)
            .subscribe(
                data => {
                    var that = this;
                  
                   

                    if (data.status.code) {
                        //   that.toastr.error(that.homeService.getTranslate('login.error'));
                        document.body.classList.remove('jw-modal-open');
                        this.loading = false;
                    } else {
                        location.href = this.returnUrl;
                    }
                    if (data.status.code == 1) {
                        var that = this;
                        that.toastr.error(that.homeService.getTranslate('login.error'));
                    }
                    // this.router.navigate([this.returnUrl]);
                },
                error => {
                    this.toastr.error(error)
                    document.body.classList.remove('jw-modal-open');
                    this.loading = false;
                });
    }
}
